import { TimeCardsColumns } from "./columns";
import { z } from "zod";

export const TimeCardApprovalSchema = z.array(z.object({ type: z.enum(["in", "out"]), time: z.date() }));

// Time modifier codes for overtime, penalties, and differentials
export const TIME_MODIFIER_CODES = ["DOT", "DDT", "MP", "CP", "HOL", "DIFF"] as const;
export type TimeModifierCode = (typeof TIME_MODIFIER_CODES)[number];

export const TIME_MODIFIERS: Record<TimeModifierCode, { label: string; multiplier: number; color: string }> = {
  DOT: { label: "Daily Overtime", multiplier: 1.5, color: "#F59E0B" }, // amber
  DDT: { label: "Daily Double Time", multiplier: 2, color: "#EF4444" }, // red
  MP: { label: "Meal Penalty", multiplier: 1.5, color: "#8B5CF6" }, // purple
  CP: { label: "Callback Penalty", multiplier: 1.5, color: "#EC4899" }, // pink
  HOL: { label: "Holiday", multiplier: 1.5, color: "#10B981" }, // green
  DIFF: { label: "Differential", multiplier: 1.25, color: "#06B6D4" }, // cyan
};

export const TimeCardMetaSchema = z.object({
  note: z.string().optional(),
  modifiers: z.array(z.enum(TIME_MODIFIER_CODES)).optional(),
});

export const TimeCardTimeSchema = z.object({
  start_time: z.string().optional(),
  end_time: z.string().optional(),
  meal_start: z.string().optional(),
  meal_end: z.string().optional(),
});

export type TimeCardMetaType = z.infer<typeof TimeCardMetaSchema>;
export type TimeCardTimeType = z.infer<typeof TimeCardTimeSchema>;

export type TimecardType = Omit<TimeCardsColumns, "meta_data" | "time"> & {
  meta_data?: TimeCardMetaType;
  time?: TimeCardTimeType;
};
